import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface Restaurant {
  _id: string;
  name: string;
  slug: string;
  description?: string;
  phone?: string;
  image?: string;
  logo?: string;
  coverImage?: string;
  address?: {
    street: string;
    city: string;
    state?: string;
    postcode: string;
    country: string;
  };
  isActive: boolean;
  /** The business this restaurant is an outlet of, if any. */
  business?: { _id: string; name: string; status?: string } | null;
  rating?: number;
  totalReviews?: number;
}

@Injectable({
  providedIn: 'root'
})
export class RestaurantService {
  private apiUrl = `${environment.apiUrl}/restaurants`;

  constructor(private http: HttpClient) {}

  getAllRestaurants(): Observable<any> {
    return this.http.get(`${this.apiUrl}/fetch-all-restaurants`);
  }

  getRestaurantById(id: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/fetch-restaurantby-id/${id}`);
  }

  getMyRestaurant(): Observable<any> {
    return this.http.get(`${this.apiUrl}/my-restaurant`);
  }

  getRestaurantByDomain(domain: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/by-domain/${domain}`);
  }

  getPublicRestaurant(id: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/public/${id}`);
  }

  updateGeneralSettings(restaurantId: string, generalSettings: any): Observable<any> {
    return this.http.patch(`${this.apiUrl}/${restaurantId}/general-settings`, { generalSettings });
  }
}
